import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import adminApi from '../../../APIs/admin';
import printerApi from '../../../APIs/printer';
import AdditionalInformation from '../../../components/PrinterBrowsedClientDetails/AdditionalInformation';
import UserInformation from '../../../components/PrinterBrowsedClientDetails/UserInformation';
import UserProfile from '../../../components/UserDetails/UserProfile';
import { useRoot } from '../../../context/RootProvider';
import { Divider, NavigateBack, Typography } from '../../../designComponents';
import { RootState } from '../../../store/selectors';
import { requestAPI } from '../../../utils';
import { PrinterDetailsContainerStyled } from '../../PrinterJobs/PrinterJobDetails/style';
const PrinterClientDetails = () => {
  const clientPrinter = useSelector(
    (state: RootState) => state.singleClient.data,
  );
  const singleUser = useSelector((state: RootState) => state.singleClientData);

  const { clientId } = useParams();
  const { auth } = useRoot();

  const getSingleUser = async () => {
    try {
      if (typeof clientId !== 'undefined') {
        await requestAPI(adminApi.getSingleUser(clientId));
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  const fetchClient = async (id: string) => {
    try {
      await requestAPI(printerApi.getPrinterClientDetailById(id || ''));
    } catch (error) {
      console.error(error);
    }
  };
  const checkRole = () => {
    if (auth?.role === 'ADMIN') {
      return getSingleUser();
    }
    return fetchClient(clientId || '');
  };
  useEffect(() => {
    checkRole();
  }, []);

  return (
    <PrinterDetailsContainerStyled>
      <div
        style={{
          position: 'sticky',
          top: '60px',
          zIndex: '999',
          paddingTop: '5px',
        }}
      >
        <NavigateBack />
      </div>
      <div className="container">
        <div className="heading">
          <Typography variant="title" className="heading">
            Client Details{' '}
          </Typography>
        </div>
        <Divider spaceY="20px" />

        {auth?.role === 'ADMIN' ? (
          singleUser && (
            <>
              <UserProfile
                name={singleUser?.fullName}
                email={singleUser?.emailAddress}
                position={singleUser?.role || 'Fire Team'}
              />
              <Divider spaceY="20px" />

              <UserInformation
                userName={singleUser?.fullName || ''}
                userType={singleUser?.role || ''}
                userEmail={singleUser?.emailAddress || ''}
                contactNumber={singleUser?.mobileNumber || ''}
                userAddress={
                  singleUser?.contactInfo?.address1.concat(
                    ', ',
                    singleUser.contactInfo.city,
                  ) ?? 'Tinkune, Kathmandu'
                }
              />
              <Divider spaceY="20px" />
              <AdditionalInformation
                shippingAddress={
                  clientPrinter?.shippingAddress || 'Tinkune, Kathmandu'
                }
              />
            </>
          )
        ) : (
          <>
            <UserProfile
              name={clientPrinter.fullName}
              email={clientPrinter?.emailAddress}
              position={clientPrinter?.role}
            />
            <Divider spaceY="20px" />

            <UserInformation
              userName={clientPrinter?.fullName}
              userType={clientPrinter?.role || ''}
              userEmail={clientPrinter?.emailAddress}
              contactNumber={clientPrinter?.mobileNumber || ''}
              userAddress={
                clientPrinter?.contactInfo.address1 +
                  ', ' +
                  clientPrinter?.contactInfo.address2 || ''
              }
            />
            <Divider spaceY="20px" />
            <AdditionalInformation
              shippingAddress={
                clientPrinter?.shippingAddress || 'Tinkune, Kathmandu'
              }
            />
          </>
        )}
      </div>
    </PrinterDetailsContainerStyled>
  );
};

export default PrinterClientDetails;
